<script>
    import { format } from "svelte-i18n";
    let { value } = $props();
    let data = $derived(value);
</script>
<div class="text-end">
    <button
        class="btn btn-default bg-light"
        data-bs-toggle="modal"
        data-bs-target="#snapshot-report-modal"
        onclick={() =>
            data.getSnapshotDetail(data.id, {
                resetFilters: ["asset_tag", "finding_tag", "vulnerability_tag"],
            })
        }
    >
        <i class="fas fa-file-contract" style="color: #666 !important;"></i>
        {$format("page.snapshot.generate_report_btn")}
    </button>
</div>
<style>
    button {
        position: relative;
        /*z-index: 99999999999999999999999;*/
    }
    button i {
        font-size: 16px;
    }
</style>
